import rp, { CodeEditorOptions, ContentOptions } from "@reporting/rp-app-host";
import { Resource } from "@reporting/rp-types/ext";
import { HtmlEditorAdapter } from "../components/htmlEditor";

export class ExtensionHtmlEditorAdapter extends HtmlEditorAdapter {

	private _resource: Resource;

	constructor(readonly id: number) { super() }

	async getResource() : Promise<Resource> {
		if (this._resource) return this._resource;
		this._resource = this.id ? await rp.ms('extensions').get<Resource>(`resources/${this.id}`) : {};
		return this._resource;
	}

	async getContent(opt: ContentOptions) : Promise<string> {
		return await rp.ms('extensions').get<string>(`resourceContent/${this.id}`);
	}

	async save(content: string): Promise<boolean> {
		await rp.ms('extensions').post(`resourceContent/${this.id}`, content);
		return true;
	}

	async getOptions(): Promise<CodeEditorOptions> {
		return this.createOptions({
			history: false
		});
	}
}
